import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRealmComponent } from './simple-icons-realm.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRealmComponent ],
    exports:      [ SimpleIconsRealmComponent ],
    bootstrap:    []
})
export class SimpleIconsRealmModule {}
